import { render, staticRenderFns } from "./WidgetProfile.vue?vue&type=template&id=0bbfc290&scoped=true"
import script from "./WidgetProfile.vue?vue&type=script&lang=js"
export * from "./WidgetProfile.vue?vue&type=script&lang=js"
import style0 from "./WidgetProfile.vue?vue&type=style&index=0&id=0bbfc290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbfc290",
  null
  
)

export default component.exports